import * as React from 'react'

type TProps = RequiredChildren & {
  onError(error: Error): void
}

/**
 * Only class components can be error boundaries. Error boundaries work like a JavaScript catch {} block, but for components.
 * https://reactjs.org/docs/error-boundaries.html
 */
export class ClassErrorBoundary extends React.PureComponent<TProps> {
  componentDidCatch(error: Error) {
    this.props.onError(error)
  }

  static getDerivedStateFromError() {
    // has to be here, causing warning otherwise
    return {}
  }

  render() {
    return this.props.children
  }
}
